"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FirstDayOfWeek = void 0;
var _button = _interopRequireDefault(require("@clayui/button"));
var _dropDown = _interopRequireDefault(require("@clayui/drop-down"));
var _form = require("@clayui/form");
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _shared = require("@clayui/shared");
var _react = _interopRequireWildcard(require("react"));
var _DateNavigation = _interopRequireDefault(require("./DateNavigation"));
var _DayNumber = _interopRequireDefault(require("./DayNumber"));
var _DaysTable = _interopRequireDefault(require("./DaysTable"));
var _Helpers = require("./Helpers");
var _Hooks = require("./Hooks");
var _InputDate = _interopRequireDefault(require("./InputDate"));
var _TimePicker = _interopRequireDefault(require("./TimePicker"));
var _Weekday = _interopRequireDefault(require("./Weekday"));
var _WeekdayHeader = _interopRequireDefault(require("./WeekdayHeader"));
var _excluded = ["ariaLabels", "dateFormat", "defaultExpanded", "defaultMonth", "defaultValue", "disabled", "expanded", "firstDayOfWeek", "footerElement", "id", "initialExpanded", "initialMonth", "inputName", "months", "onChange", "onExpandedChange", "onNavigation", "onValueChange", "placeholder", "range", "spritemap", "time", "timezone", "use12Hours", "useNative", "value", "weekdaysShort", "years", "yearsCheck"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var FirstDayOfWeek;
(function (FirstDayOfWeek) {
  FirstDayOfWeek[FirstDayOfWeek["Sunday"] = 0] = "Sunday";
  FirstDayOfWeek[FirstDayOfWeek["Monday"] = 1] = "Monday";
  FirstDayOfWeek[FirstDayOfWeek["Tuesday"] = 2] = "Tuesday";
  FirstDayOfWeek[FirstDayOfWeek["Wednesday"] = 3] = "Wednesday";
  FirstDayOfWeek[FirstDayOfWeek["Thursday"] = 4] = "Thursday";
  FirstDayOfWeek[FirstDayOfWeek["Friday"] = 5] = "Friday";
  FirstDayOfWeek[FirstDayOfWeek["Saturday"] = 6] = "Saturday";
})(FirstDayOfWeek || (exports.FirstDayOfWeek = FirstDayOfWeek = {}));
var DEFAULT_DATE_TIME = {
  hours: 12,
  milliseconds: 0,
  minutes: 0,
  seconds: 0
};
var NEW_DATE = new Date();
var TIME_FORMAT = 'HH:mm';
var TIME_FORMAT_12H = 'hh:mm aa';
var normalizeTime = function normalizeTime(date) {
  return (0, _Helpers.setDate)(date, {
    hours: 12,
    milliseconds: 0,
    minutes: 0,
    seconds: 0
  });
};
var DatePicker = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _ref$ariaLabels = _ref.ariaLabels,
    ariaLabels = _ref$ariaLabels === void 0 ? {
      buttonChooseDate: 'Choose date',
      buttonDot: 'Select current date',
      buttonNextMonth: 'Select the next month',
      buttonPreviousMonth: 'Select the previous month',
      chooseDate: 'Use the calendar to choose a Date. Current selection {0}',
      dialog: 'Choose date',
      openCalendar: 'Open Calendar Picker',
      selectMonth: 'Select a month',
      selectYear: 'Select a year'
    } : _ref$ariaLabels,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? 'yyyy-MM-dd' : _ref$dateFormat,
    defaultExpanded = _ref.defaultExpanded,
    defaultMonth = _ref.defaultMonth,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    expanded = _ref.expanded,
    _ref$firstDayOfWeek = _ref.firstDayOfWeek,
    firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? 0 : _ref$firstDayOfWeek,
    footerElement = _ref.footerElement,
    id = _ref.id,
    _ref$initialExpanded = _ref.initialExpanded,
    initialExpanded = _ref$initialExpanded === void 0 ? false : _ref$initialExpanded,
    _ref$initialMonth = _ref.initialMonth,
    initialMonth = _ref$initialMonth === void 0 ? NEW_DATE : _ref$initialMonth,
    inputName = _ref.inputName,
    _ref$months = _ref.months,
    months = _ref$months === void 0 ? ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'] : _ref$months,
    onChange = _ref.onChange,
    onExpandedChange = _ref.onExpandedChange,
    _ref$onNavigation = _ref.onNavigation,
    onNavigation = _ref$onNavigation === void 0 ? function () {} : _ref$onNavigation,
    onValueChange = _ref.onValueChange,
    placeholder = _ref.placeholder,
    range = _ref.range,
    spritemap = _ref.spritemap,
    _ref$time = _ref.time,
    time = _ref$time === void 0 ? false : _ref$time,
    timezone = _ref.timezone,
    _ref$use12Hours = _ref.use12Hours,
    use12Hours = _ref$use12Hours === void 0 ? false : _ref$use12Hours,
    _ref$useNative = _ref.useNative,
    useNative = _ref$useNative === void 0 ? false : _ref$useNative,
    value = _ref.value,
    _ref$weekdaysShort = _ref.weekdaysShort,
    weekdaysShort = _ref$weekdaysShort === void 0 ? ['S', 'M', 'T', 'W', 'T', 'F', 'S'] : _ref$weekdaysShort,
    _ref$years = _ref.years,
    years = _ref$years === void 0 ? {
      end: NEW_DATE.getFullYear(),
      start: NEW_DATE.getFullYear()
    } : _ref$years,
    _ref$yearsCheck = _ref.yearsCheck,
    yearsCheck = _ref$yearsCheck === void 0 ? true : _ref$yearsCheck,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // For backward compatibility `defaultMonth` is just an alias for
  // `initialMonth`.
  initialMonth = defaultMonth !== null && defaultMonth !== void 0 ? defaultMonth : initialMonth;
  var _useControlledState = (0, _shared.useControlledState)({
      defaultName: 'defaultValue',
      defaultValue: defaultValue,
      handleName: 'onChange',
      name: 'value',
      onChange: onChange !== null && onChange !== void 0 ? onChange : onValueChange,
      value: value
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 3),
    internalValue = _useControlledState2[0],
    setValue = _useControlledState2[1],
    isUncontrolled = _useControlledState2[2];

  /**
   * DaysSelected is a tuple that represents [startDate, endDate]
   * in the cases where We have a date range and when `range` property
   * is disabled we will just use the first element of the tuple(startDate)
   */
  var _useDaysSelected = (0, _Hooks.useDaysSelected)(function () {
      if (internalValue) {
        var days = hasDaysSelected({
          checkRangeYears: yearsCheck,
          dateFormat: dateFormat,
          is12Hours: use12Hours,
          isTime: time,
          value: internalValue,
          years: years
        });
        if (days) {
          return [normalizeTime(days[0]), normalizeTime(days[1])];
        }
      }
      var date = normalizeTime(initialMonth);
      return [date, date];
    }),
    _useDaysSelected2 = _slicedToArray(_useDaysSelected, 2),
    daysSelected = _useDaysSelected2[0],
    setDaysSelected = _useDaysSelected2[1];

  /**
   * Indicates the current month rendered on the screen.
   */
  var _useState = (0, _react.useState)(function () {
      return (
        // Normalize the date to always set noon to avoid time zone problems
        // and to the 1st of the month.
        (0, _Helpers.setDate)(daysSelected[0], _objectSpread({
          date: 1
        }, DEFAULT_DATE_TIME))
      );
    }),
    _useState2 = _slicedToArray(_useState, 2),
    currentMonth = _useState2[0],
    setCurrentMonth = _useState2[1];
  var chooseDateRef = (0, _react.useRef)(null);

  /**
   * Indicates the time selected by the user.
   */
  var _useCurrentTime = (0, _Hooks.useCurrentTime)(function () {
      if (time && internalValue) {
        var _fromStringToRange = fromStringToRange(internalValue, "".concat(dateFormat, " ").concat(use12Hours ? TIME_FORMAT_12H : TIME_FORMAT), NEW_DATE),
          _fromStringToRange2 = _slicedToArray(_fromStringToRange, 1),
          startDate = _fromStringToRange2[0];
        if (startDate.toString() !== 'Invalid Date') {
          var hours = use12Hours ? (0, _Helpers.formatDate)(startDate, 'hh') : (0, _Helpers.formatDate)(startDate, 'HH');
          var minutes = (0, _Helpers.formatDate)(startDate, 'mm');
          return use12Hours ? "".concat(hours, ":").concat(minutes, " ").concat((0, _Helpers.formatDate)(startDate, 'a')) : "".concat(hours, ":").concat(minutes);
        }
      }
      return '--:--';
    }, use12Hours),
    _useCurrentTime2 = _slicedToArray(_useCurrentTime, 2),
    currentTime = _useCurrentTime2[0],
    setCurrentTime = _useCurrentTime2[1];

  /**
   * An array of the weeks and days list for the current month
   */
  var _useWeeks = (0, _Hooks.useWeeks)(currentMonth, firstDayOfWeek),
    _useWeeks2 = _slicedToArray(_useWeeks, 2),
    weeks = _useWeeks2[0],
    setWeeks = _useWeeks2[1];

  /**
   * Flag to indicate if date is expanded. Uses an internal state value
   * if component is not controlled by props.
   */
  var _useControlledState3 = (0, _shared.useControlledState)({
      defaultName: 'defaultExpanded',
      defaultValue: defaultExpanded === undefined ? initialExpanded : defaultExpanded,
      handleName: 'onExpandedChange',
      name: 'expanded',
      onChange: onExpandedChange,
      value: expanded
    }),
    _useControlledState4 = _slicedToArray(_useControlledState3, 2),
    expandedValue = _useControlledState4[0],
    setExpandedValue = _useControlledState4[1];

  /**
   * Create a ref to store the datepicker DOM element
   */
  var triggerElementRef = (0, _react.useRef)(null);

  /**
   * Handles the change of the current month of the Date Picker
   * content and takes care of updating the weeks.
   */
  var changeMonth = function changeMonth(date) {
    var dateNormalized = (0, _Helpers.setDate)(date, _objectSpread({
      date: 1
    }, DEFAULT_DATE_TIME));
    setCurrentMonth(dateNormalized);
    onNavigation(dateNormalized);

    // It is not necessary to update the weeks when the native
    // date is enabled. Unnecessary rendering and processing.
    if (!useNative) {
      setWeeks(dateNormalized);
    }
  };
  var memoizedYears = (0, _react.useMemo)(function () {
    return (0, _Helpers.range)(years).map(function (elem) {
      return {
        label: elem,
        value: elem
      };
    });
  }, [years]);
  var memoizedMonths = (0, _react.useMemo)(function () {
    return months.map(function (month, index) {
      return {
        label: month,
        value: index
      };
    });
  }, [months]);

  /**
   * Handles the click on element of the day
   */
  var handleDayClicked = function handleDayClicked(date) {
    var _daysSelected = _slicedToArray(daysSelected, 2),
      startDate = _daysSelected[0],
      endDate = _daysSelected[1];
    var newDaysSelected;
    var daysSelectedToString;
    if (range) {
      if (startDate.toString() !== endDate.toString()) {
        newDaysSelected = [date, date];
      } else if (date < startDate) {
        newDaysSelected = [date, endDate];
      } else {
        newDaysSelected = [startDate, date];
      }
      daysSelectedToString = fromRangeToString(newDaysSelected, dateFormat);
      var _newDaysSelected = newDaysSelected,
        _newDaysSelected2 = _slicedToArray(_newDaysSelected, 2),
        newStartDate = _newDaysSelected2[0],
        newEndDate = _newDaysSelected2[1];
      if (newStartDate.getMonth() !== newEndDate.getMonth()) {
        changeMonth(startDate);
      }
    } else {
      newDaysSelected = [date, date];
      daysSelectedToString = (0, _Helpers.formatDate)(date, dateFormat);
      if (time) {
        daysSelectedToString = "".concat(daysSelectedToString, " ").concat(currentTime);
      }
    }
    setDaysSelected(newDaysSelected);
    setValue(daysSelectedToString);
  };
  var updateDate = (0, _react.useCallback)(function (value) {
    if (!value) {
      changeMonth(initialMonth);
      setDaysSelected([initialMonth, initialMonth]);
      if (time) {
        setCurrentTime('--', '--', undefined);
      }
    } else {
      var days = hasDaysSelected({
        checkRangeYears: yearsCheck,
        dateFormat: dateFormat,
        is12Hours: use12Hours,
        isTime: time,
        value: value,
        years: years
      });
      if (days) {
        var _days = _slicedToArray(days, 2),
          startDate = _days[0],
          endDate = _days[1];
        changeMonth(startDate);
        setDaysSelected([startDate, endDate]);
        if (time) {
          setCurrentTime(startDate.getHours(), startDate.getMinutes(), use12Hours ? (0, _Helpers.formatDate)(startDate, 'a') : undefined);
        }
      }
    }
  }, [dateFormat, use12Hours, time, years, yearsCheck]);

  /**
   * Control the value of the input propagating with the call
   * of `onChange` but does not change what the user types,
   * if a date is valid the month of the Date Picker is changed.
   */
  var inputChange = function inputChange(event) {
    var value = event.target.value;
    updateDate(value);
    setValue(value);
  };
  (0, _react.useEffect)(function () {
    if (!isUncontrolled) {
      updateDate(internalValue);
    }
  }, [isUncontrolled, internalValue]);

  /**
   * Changes selected date to the current date. The same happens when there
   * is no date selected.
   */
  var handleDotClicked = function handleDotClicked() {
    var _daysSelected2 = _slicedToArray(daysSelected, 2),
      endDate = _daysSelected2[1];
    changeMonth(initialMonth);
    var newDaysSelected = range && endDate < initialMonth ? [endDate, initialMonth] : [initialMonth, endDate];
    var dateFormatted;
    if (range) {
      dateFormatted = fromRangeToString(newDaysSelected, dateFormat);
    } else if (time) {
      dateFormatted = "".concat((0, _Helpers.formatDate)(initialMonth, dateFormat), " ").concat(setCurrentTime(initialMonth.getHours(), initialMonth.getMinutes(), use12Hours ? (0, _Helpers.formatDate)(initialMonth, 'a') : undefined));
    } else {
      dateFormatted = (0, _Helpers.formatDate)(initialMonth, dateFormat);
    }
    setDaysSelected(newDaysSelected);
    setValue(dateFormatted);
  };
  var handleTimeChange = function handleTimeChange(hours, minutes, ampm) {
    var _daysSelected3 = _slicedToArray(daysSelected, 1),
      day = _daysSelected3[0];
    if (hours === '--' && typeof minutes === 'number') {
      hours = 0;
    }
    if (minutes === '--' && typeof hours === 'number') {
      minutes = 0;
    }
    if (internalValue) {
      var date = typeof hours === 'string' && typeof minutes === 'string' ? "".concat((0, _Helpers.formatDate)(day, dateFormat), " ").concat(hours, ":").concat(minutes) : (0, _Helpers.formatDate)((0, _Helpers.setDate)(day, {
        hours: hours,
        minutes: minutes
      }), "".concat(dateFormat, " ").concat(TIME_FORMAT));
      if (use12Hours) {
        date += " ".concat(ampm);
      }
      setValue(date);
    }
    setCurrentTime(hours, minutes, use12Hours ? ampm : undefined);
  };

  /**
   * Handles datepicker view
   */
  var handleCalendarButtonClicked = function handleCalendarButtonClicked() {
    return setExpandedValue(!expandedValue);
  };
  var calendarNavigation = (0, _Hooks.useCalendarNavigation)({
    daysSelected: daysSelected,
    isOpen: expandedValue,
    onChangeMonth: function onChangeMonth(month, year) {
      if (typeof year === 'number') {
        changeMonth((0, _Helpers.setDate)(currentMonth, {
          year: currentMonth.getFullYear() + year
        }));
      } else {
        var date = (0, _Helpers.setMonth)(memoizedYears, month, currentMonth);
        if (date) {
          changeMonth(date);
        }
      }
    },
    weeks: weeks
  });
  var ariaControls = (0, _shared.useId)();
  return /*#__PURE__*/_react.default.createElement(_shared.FocusScope, {
    arrowKeysUpDown: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker"
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput.Group, {
    ref: triggerElementRef
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, {
    className: "input-group-item-focusable"
  }, /*#__PURE__*/_react.default.createElement(_InputDate.default, _extends({}, otherProps, {
    ariaLabel: ariaLabels.input,
    disabled: disabled,
    id: id,
    inputName: inputName,
    onChange: inputChange,
    placeholder: placeholder,
    ref: ref,
    useNative: useNative,
    value: internalValue
  })), !useNative && /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupInsetItem, {
    after: true
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    "aria-controls": ariaControls,
    "aria-expanded": expandedValue,
    "aria-haspopup": "dialog",
    "aria-label": ariaLabels.buttonChooseDate,
    className: "date-picker-dropdown-toggle",
    disabled: disabled,
    displayType: "unstyled",
    onClick: handleCalendarButtonClicked,
    ref: chooseDateRef,
    title: ariaLabels.openCalendar
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "calendar"
  }))))), !useNative && /*#__PURE__*/_react.default.createElement(_dropDown.default.Menu, {
    active: expandedValue,
    alignElementRef: triggerElementRef,
    "aria-label": ariaLabels.dialog,
    className: "date-picker date-picker-dropdown-menu",
    id: ariaControls,
    lock: true,
    onActiveChange: setExpandedValue,
    role: "dialog",
    triggerRef: chooseDateRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-label": ariaLabels.chooseDate && (0, _shared.sub)(ariaLabels.chooseDate, [(0, _Helpers.formatDate)(currentMonth, 'MMMM yyyy')]),
    className: "date-picker-calendar",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement(_DateNavigation.default, {
    ariaLabels: ariaLabels,
    currentMonth: currentMonth,
    disabled: disabled,
    months: memoizedMonths,
    onDotClicked: handleDotClicked,
    onMonthChange: changeMonth,
    spritemap: spritemap,
    years: memoizedYears
  }), /*#__PURE__*/_react.default.createElement("div", _extends({}, calendarNavigation.gridProps, {
    className: "date-picker-calendar-body",
    role: "grid"
  }), /*#__PURE__*/_react.default.createElement(_WeekdayHeader.default, {
    firstDayOfWeek: firstDayOfWeek,
    weekdaysShort: weekdaysShort
  }, function (_ref2) {
    var key = _ref2.key,
      weekday = _ref2.weekday;
    return /*#__PURE__*/_react.default.createElement(_Weekday.default, {
      key: key,
      weekday: weekday
    });
  }), /*#__PURE__*/_react.default.createElement(_DaysTable.default, {
    weeks: weeks
  }, function (_ref3) {
    var day = _ref3.day,
      key = _ref3.key;
    return /*#__PURE__*/_react.default.createElement(_DayNumber.default, {
      day: day,
      daysSelected: daysSelected,
      disabled: disabled,
      index: key,
      isFocused: calendarNavigation.isFocused(day),
      key: key,
      onClick: handleDayClicked,
      range: range
    });
  })), (footerElement || time) && /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-calendar-footer"
  }, time && /*#__PURE__*/_react.default.createElement(_TimePicker.default, {
    currentTime: currentTime,
    disabled: disabled,
    onTimeChange: handleTimeChange,
    spritemap: spritemap,
    timezone: timezone,
    use12Hours: use12Hours
  }), !time && footerElement && _react.default.Children.only(footerElement({
    spritemap: spritemap
  })))))));
});
var RANGE_SEPARATOR = ' - ';
function isYearWithinYears(year, years) {
  return years.start <= year && year <= years.end;
}
function fromStringToRange(value, dateFormat, referenceDate) {
  var _value$split = value.split(RANGE_SEPARATOR),
    _value$split2 = _slicedToArray(_value$split, 2),
    startDateString = _value$split2[0],
    endDateString = _value$split2[1];
  var startDate = (0, _Helpers.parseDate)(startDateString, dateFormat, referenceDate);
  return [startDate, endDateString ? (0, _Helpers.parseDate)(endDateString, dateFormat, referenceDate) : startDate];
}
function hasDaysSelected(_ref4) {
  var checkRangeYears = _ref4.checkRangeYears,
    dateFormat = _ref4.dateFormat,
    is12Hours = _ref4.is12Hours,
    isTime = _ref4.isTime,
    value = _ref4.value,
    years = _ref4.years;
  var _fromStringToRange3 = fromStringToRange(value, isTime ? "".concat(dateFormat, " ").concat(is12Hours ? TIME_FORMAT_12H : TIME_FORMAT) : dateFormat, NEW_DATE),
    _fromStringToRange4 = _slicedToArray(_fromStringToRange3, 2),
    startDate = _fromStringToRange4[0],
    endDate = _fromStringToRange4[1];
  var isValidYear = checkRangeYears ? isYearWithinYears(startDate.getFullYear(), years) && isYearWithinYears(endDate.getFullYear(), years) : true;
  if ((0, _Helpers.isValid)(startDate) && (0, _Helpers.isValid)(endDate) && isValidYear) {
    return [startDate, endDate];
  }
}
function fromRangeToString(range, dateFormat) {
  var _range = _slicedToArray(range, 2),
    startDate = _range[0],
    endDate = _range[1];
  return "".concat((0, _Helpers.formatDate)(startDate, dateFormat)).concat(RANGE_SEPARATOR).concat((0, _Helpers.formatDate)(endDate, dateFormat));
}
DatePicker.displayName = 'ClayDatePicker';
var _default = exports.default = DatePicker;